<template lang='pug'>
  v-container(fill-height)
    v-row(align='center' justify='center')
      .text-h5.grey--text {{message}}
</template>

<script>

export default {
  name: 'BionicMetricsNoData',
  props: {
    message: {
      type: String,
      default: 'No Data'
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
